import Center from 'shared/components/Center'
import styled from 'styled-components'

import Button from '../../../../shared/components/Button'
import { Feedback } from '../../../../shared/components/Feedback'
import Page from '../../../../shared/components/Page'
import dimensions from 'shared/styles/dimensions'
import { colors } from '../../../../shared/styles/colors'

export const StyledPage = styled(Page)`
  padding: 50px 0px;

  @media (max-width: 320px) {
    min-height: 800px;
  }

  @media (min-width: 320px) {
    min-height: 800px;
  }
`

export const ContainerForm = styled.div`
  display: flex;

  width: 513px;
  flex-direction: column;
  align-items: center;

  input {
    margin: ${dimensions.spaces.small}px 0;
  }

  @media (max-width: 320px) {
    width: 200px;
  }

  @media (min-width: 320px) {
    width: 300px;
  }

  @media (min-width: 480px) {
    width: 440px;
  }
`
export const ContainerInput = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`

export const ContainerButton = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
`

export const StyledButton = styled(Button)`
  position: absolute;
  bottom: 1.5rem;

  @media (max-width: 320px) {
    position: relative;
    bottom: -5.5rem;
    right: -45px;
  }
  @media (max-height: 669px) {
    position: relative;
    bottom: -1.5rem;
  }
  @media (max-height: 820px) {
    position: relative;
    bottom: -1.5rem;
  }
`

export const StyledFeedback = styled(Feedback)`
  padding: 65px 0px;
  width: 100%;
`

export const StyledCenter = styled(Center)`
  position: absolute;
`

export const Icon = styled.div`
  color: ${colors.gray};
  width: 16px;
  height: 16px;
  margin-left: -2rem;
`

export const HelperMessage = styled.span`
  font-weight: bold;
  font-size: 18;
  color: ${colors.red};
`

export const ButtonShowPassword = styled.button`
  display: flex;
  align-items: center;

  border: none;
  background: transparent;
`
